'use strict';

const _=require('pulsar-utils/dist-es6/_');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

MultiViewDirective=class MultiViewDirective extends BaseControllerBackedDirective{
get objectBindings(){
return['views','selectedView','self'];
}

get textBindings(){
return['stickyId'];
}

get templateUrl(){
return'/templates/directives/multiViewDirective/multiViewTemplate';
}

get controller(){
return MultiViewDirectiveController;
}};let


MultiViewDirectiveController=class MultiViewDirectiveController{
static get $inject(){
return['$scope','$state','$compile','$element','displaySettingsService'];
}

constructor($scope,$state,$compile,$element,displaySettingsService){
this._$scope=$scope;
this._$state=$state;
this._$compile=$compile;
this._$element=$element;
this._displaySettingsService=displaySettingsService;

this._$scope.$on('$destroy',()=>{
if(_.exists(this._currentViewScope)){
this._currentViewScope.$destroy();
}
});

this._$scope.$watch(`controller._$state.params["${this.stickyId}TabSelection"]`,(newIndex,oldIndex)=>{
if(!_.exists(newIndex)||newIndex===oldIndex){
return;
}

if(newIndex===-1){
this._selectDefaultIndex();
return;
}

this.selectViewAtIndex(newIndex);
});

this._selectDefaultIndex();
}

_selectDefaultIndex(){
const lastSelectedIndex=this._displaySettingsService.getMultiViewSelectionFor(this.stickyId);
const paramIndex=_.get(this._$state,`params["${this.stickyId}TabSelection"]`);

this.select(this.views[paramIndex]||this.views[lastSelectedIndex]||this.views[0]);
}

select(view){
if(!_.exists(view)){
this._selectDefaultIndex();
return;
}

if(this._selectedView===view){
return;
}

this._loadView(view);
this._displaySettingsService.setMultiViewSelection(this.stickyId,this.views.indexOf(view));
}

get self(){
return this;
}

set self(nope){

}

selectViewAtIndex(index){
this.select(this.views[index]);
}

reloadCurrentView(){
this._loadView(this._selectedView);
}

_loadView(view){
this._selectedView=view;

let inflatedBindings='';
if(_.exists(view.bindings)){
for(let binding in view.bindings){
inflatedBindings+=` ${binding}=$parent.$parent.${view.bindings[binding]}`;
}
}

if(_.exists(this._currentViewScope)){
this._currentViewScope.$destroy();
}

this._currentViewScope=this._$scope.$new(!0,this._$scope);
this._currentView.innerHTML=`<${view.directiveName} ${inflatedBindings} multi-view-parent='$parent.controller'></${view.directiveName}>`;

this._$compile(this._currentView)(this._currentViewScope);

const stateName=_.get(this._$state,'current.name');
this._$state.go(stateName,{
[this.stickyId+'TabSelection']:this.views.indexOf(view)});

}

get selectedView(){
return this._selectedView;
}

set selectedView(val){

}

get _currentView(){
return this.__currentView||(this.__currentView=this._$element.find('.current-view')[0]);
}};



module.exports=MultiViewDirective;
//# sourceMappingURL=multiViewDirective.js.map
